import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  background-size: cover;
  background-repeat: no-repeat;
  height: 80vh;
  width: 100%;
  max-width: 1920px;
  margin: auto;
  color: black;
  position: relative;
  h1 {
    margin-top: 5rem;
    z-index: 2;
    font-size: 2rem;
  }
  p {
    max-width: 700px;
    z-index: 2;
    font-size: 18px;
  }
  .sub-text {
    color: #6f7a80;
  }
  a {
    color: black;
    font-weight: 700;
    &:visited {
      color: black;
    }
  }
  @media (min-width: 1024px) {
    display: flex;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    justify-content: start;
    h1 {
      font-size: 3rem;
    }
    p {
      font-size: 24px;
    }
  }
`;
